import { useLazyQuery, useQuery } from "@apollo/client";
import { PROMPT_FRAGMENT } from "../prompt-fragment.queries";
import {
  PromptFragmentQuery,
  PromptFragmentQueryVariables,
} from "../../../__generated__/PromptFragmentQuery";

export const usePromptFragment = (id: number) => {
  return useQuery<PromptFragmentQuery, PromptFragmentQueryVariables>(PROMPT_FRAGMENT, {
    variables: { id },
  });
};

export const useLazyPromptFragment = () => {
  return useLazyQuery<PromptFragmentQuery, PromptFragmentQueryVariables>(PROMPT_FRAGMENT);
};
